import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import type { QueryClient } from '@tanstack/react-query'
import { DeathScreen } from '@/widgets/death-screen'
import { NotFoundPage } from '@/pages/not-found'
import { rootSearchSchema } from './search'

export type RouterContext = {
  queryClient: QueryClient
}

/**
 * `notFoundComponent` здесь — не только для действительно неизвестных путей: `throw notFound()`
 * из любого дочернего роута (см. routes/studio.ts) бежит вверх до ближайшего роута со своим
 * `notFoundComponent`, и это единственный, который его определяет.
 */
export const rootRoute = createRootRouteWithContext<RouterContext>()({
  validateSearch: rootSearchSchema,
  component: Outlet,
  errorComponent: ({ error }) => <DeathScreen error={error} />,
  notFoundComponent: () => <NotFoundPage />,
})
